<div class="botoes-filtros">
  <div class="float-right">
    <a translate class="btn btn-outline-info"
      href="http://ajuda.nbsi.com.br:84/index.php/Solu%C3%A7%C3%B5es_Web_-_Portal_NBS" target="_blank">
      {{'barraConsulta.ajuda'}}
      <em class="fa fa-question"></em>
    </a>
  </div>
  <div class="clear"></div>
</div>